import React, { Component } from 'react';
import classNames from 'classnames';
import { size, map, filter, first, find, indexOf, isEmpty } from 'lodash';


import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

class DropdownSelectAdapter extends Component {

  constructor(props) {
    super(props);
    
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.selectedOptions = this.selectedOptions.bind(this);
    
    const options = map(filter(this.props.children, {type: 'option'}), (o)=> o.props)
    const { dropdownOpen } = this.props;
    
    this.state = {
      dropdownOpen,
      options
    };
    setTimeout(this.selectedOptions)
    this.setDefaultValue()
  }
  
  componentWillReceiveProps (nextProps){
    if (nextProps.children !== this.props.children){
      const options = map(filter(nextProps.children, {type: 'option'}), (o)=> o.props)
      this.setState({
        options
      });
      setTimeout(this.selectedOptions)
      this.setDefaultValue()
    }
  }
  
  setDefaultValue (){
    const { input, disabledValues } = this.props;
    const { options } = this.state;
    const optionsValues = map(options, 'value');
    const value = input && input.value;
    
    if (!value || indexOf(optionsValues, value) < 0 ){
      const availableOpts = filter(options, (option) => {
        return !(disabledValues && indexOf(disabledValues, (option.value || option.children)) > -1)
      })
      
      if ( availableOpts && size(availableOpts) > 0) {
        const firstOption = first(availableOpts);
        firstOption && this.handleChange(firstOption.value || firstOption.children)();
      }
    }
  }
  
  setOptions (children){
    const options = map(filter(children, {type: 'option'}), (o)=> o.props)
    this.setState({
      options: options
    });
    setTimeout(this.selectedOptions)
  }
  
  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }
  
  selectedOptions() {
    const { input, multiple } = this.props;
    const { options } = this.state;
    
    const values = multiple ? (input.value || []) : [input.value]
    const newOptions = map(options, (option) => {
      return {...option, selected: indexOf(values, (option.value || option.children)) > -1 }
    });
    
    this.setState({
      options: newOptions
    })
  }
  
  handleChange(value){
    const { input, multiple } = this.props;
    
    return () => {
      const newValue = multiple ? ([...((!isEmpty(input.value) && input.value) || []), value]) : value;
      input.onChange(newValue);
      this.selectedOptions()
    }
  }
  
  getOptionProps (option){
    const { input, multiple, disabledValues } = this.props;
    
    const { children, disabled } = option;
    const value = option.value || children;
    const selected = multiple ? indexOf(input.value, value) > -1 : (value === input.value);
    const disabledState = !selected && (disabled || (disabledValues && indexOf(disabledValues, value) > -1))
    
    return {value, children, active:selected, disabled: disabledState}
  }
  
  render () {
    const { input, placeholder, className, disabled, hideDisabledOptions } = this.props;
    const { options } = this.state;
    const button = find(options, {value: input.value}) || {label: placeholder || `Select`}
    
    return (
      <Dropdown className={className} isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle caret className="btn-outline-border" disabled={disabled}>
          { button.label || button.children } 
        </DropdownToggle>
        <DropdownMenu>
          {map(options, (option, idx) => {
            const optionProps = this.getOptionProps(option)
            return (!hideDisabledOptions || !optionProps.disabled) && <DropdownItem {...optionProps} key={idx} onClick={this.handleChange(optionProps.value)} className={classNames({active:optionProps.active})} />
          })}
        </DropdownMenu>
      </Dropdown>);
  }
};

export default DropdownSelectAdapter;


// WEBPACK FOOTER //
// ./src/components/form/DropdownSelectAdapter.js